import { render, staticRenderFns } from "./countPage.vue?vue&type=template&id=2f1464ee"
import script from "./countPage.vue?vue&type=script&lang=js"
export * from "./countPage.vue?vue&type=script&lang=js"
import style0 from "./countPage.vue?vue&type=style&index=0&id=2f1464ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports